import React from 'react';
import ProgressChatPanel from '../../components/ProgressChatPanel';

const ConnectChat = () => <ProgressChatPanel roleLabel="Student" />;

export default ConnectChat;
